import { render } from "./BottomNav.vue?vue&type=template&id=0ca06448"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"
script.render = render

export default script